/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "40030d8d44cb63d5f12489a12db2659d761db3c7";
